import { InjectionToken } from '@angular/core';
import { ISbComponentType } from 'storyblok-js-client';
import { IDisplayStyle, ISpacingStyle } from '@seven1/model';

export interface ITrustpilotBlock extends ISbComponentType<'trustpilot'>, ISpacingStyle, IDisplayStyle {
    componentId?: string;
    variant: 'mini' | 'horizontal' | 'slider';
}

export type TrustpilotReview = {
    id: string;
    stars: number;
    title: string;
    text: string;
    consumer: string;
    createdAt: string;
    isVerified: boolean;
};

export type TrustpilotData = {
    score: {
        trustScore: number;
        stars: number;
    };
    numberOfReviews: number;
    profileUrl: string;
    reviews: TrustpilotReview[];
    lastUpdatedAt: string;
};

export const TRUSTPILOT_SERVER_DATA = new InjectionToken<TrustpilotData>('TRUSTPILOT_SERVER_DATA');
